import { TFunction } from 'react-i18next';
import PickUpVerificationMethod from 'types/models/PickUpVerificationMethod';

export const pickUpVerificationMethodsForSelect = (
  methods: PickUpVerificationMethod[],
  t: TFunction,
): any[] | { label: string; value: number }[] => {
  if (methods.length === 0) return [];
  return methods.map((method) => {
    return {
      label: t(`${method.method.toLowerCase()}DeliveryConfig-form-option`),
      value: method.id,
    };
  });
};
